'use client';

import { useCurrentHospital } from '@/modules/appContext';
import { evaluate, IsEnabledPredicate } from '@/config';
import { ForbiddenPageContent } from '@/pages-client/ForbiddenPageContent';
import { ComponentType } from 'react';
import { SplashScreenLoader } from '@/components/loader';

export const withProtectedAccess =
  (predicate: IsEnabledPredicate) =>
  <P extends object>(Component: ComponentType<P>): ComponentType<P> => {
    const ProtectedAccessWrapper = (props: P) => {
      const {
        isUnstable,
        queryResult: { currentData: hospital }
      } = useCurrentHospital();

      if (isUnstable) {
        return <SplashScreenLoader />;
      }

      if (!evaluate(predicate, hospital)) {
        return <ForbiddenPageContent />;
      }

      return <Component {...props} />;
    };

    return ProtectedAccessWrapper;
  };
